var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPharmaCeuticals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0476 0.238281V1.85733C11.6917 1.85733 12.3094 2.1132 12.7649 2.56864C13.2203 3.02409 13.4762 3.6418 13.4762 4.2859V13.1907C13.4762 13.4054 13.3909 13.6113 13.2391 13.7631C13.0873 13.9149 12.8814 14.0002 12.6667 14.0002H1.33333C1.11863 14.0002 0.912723 13.9149 0.760908 13.7631C0.609093 13.6113 0.523804 13.4054 0.523804 13.1907V4.2859C0.523804 3.6418 0.77967 3.02409 1.23512 2.56864C1.69056 2.1132 2.30828 1.85733 2.95238 1.85733V0.238281H11.0476ZM7.80952 5.09542H6.19047V6.71447H4.57142V8.33352H6.18966L6.19047 9.95257H7.80952L7.80871 8.33352H9.42857V6.71447H7.80952V5.09542Z",
    fill: "url(#paint0_linear_590_395)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_590_395",
    x1: 6.99999,
    y1: 0.238281,
    x2: 6.99999,
    y2: 14.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmaCeuticals);
export default __webpack_public_path__ + "static/media/pharmaCeuticals.cf4fabf6ce8cb5fea60aa22d9f05955b.svg";
export { ForwardRef as ReactComponent };